// 這是Webpack掛載起始點
import permission_groups_index from '../.components/index.vue'
import permission_group_new from '../.components/new.vue'
import permission_group_edit from '../.components/edit.vue'

const main_router = 'permission_groups';
const new_router = 'new_permission_group';
const edit_router = 'edit_permission_group';

const router = [
    {
        path: '/',
        component: permission_groups_index,
        name: 'permission_groups',
        meta: {
            api_name: 'api_v1_provider_permission_groups',
            breadcrumb: [main_router],
            btns: [new_router]
        }
    },
    {
        path: 'new',
        component: permission_group_new,
        name: 'new_permission_group',
        meta: {
            api_name: 'api_v1_provider_permission_group_create',
            breadcrumb: [main_router, new_router]
        }
    },
    {
        path: ':identity/edit',
        component: permission_group_edit,
        name: 'edit_permission_group',
        meta: {
            api_name: 'api_v1_provider_permission_group_update',
            breadcrumb: [main_router, edit_router]
        }
    }
]


export default router;
